module.exports = __webpack_public_path__ + "img/rainy-2.35eb268d.svg";